import { render } from "./HomeView.vue?vue&type=template&id=6f0eb8d7"
const script = {}

import exportComponent from "/home/runner/work/tps-web-admin-portal/tps-web-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__